import { Stack, Box, Typography, Link } from '@mui/material';
import { CircularProgress } from 'components/common/CircularProgress';

import { useMsal } from '@azure/msal-react';

export const InitializationLoadingPlaceholder = () => {
  const { instance } = useMsal();

  const handleLogout = async () => {
    console.log('Logout');
    instance.logoutRedirect();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        minHeight: '90vh',
        backgroundColor: '#ffffff',
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Box>
          <img
            src="/agentsspace.png"
            alt="Agentsspace"
          />
        </Box>
        <Stack
          justifyContent="center"
          alignItems="center"
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, fontSize: '24px' }}
          >
            Initializing...
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 300, fontSize: '16px' }}
          >
            Please wait while your credentials is being validated.
          </Typography>
          <Link
            onClick={handleLogout}
            variant="body2"
            underline="hover"
            color="primary"
          >
            Logout
          </Link>
        </Stack>
        <CircularProgress />
      </Stack>
    </Box>
  );
};
